
import { auth } from "../firebase";
import { User, UserData, UserItemMapingFromDb } from "../model/Users";
import { removeNullFields, toCamelCase } from "../utility/ConvertUtily";
import axiosCilent from "./axiosClient";

export const requestGetUser = async (
  pageNo: number,
  limit: number,
  searchConditions?: any
): Promise<{
  success: true;
  users: UserData[];
  totalCount: number;
  totalPages: number;
} | { success: false; error: any }> => {
  try {
    const currentUser = auth.currentUser;
    const requestBody = {
      tenantId: `${currentUser?.tenantId}`,
      page: pageNo,
      limit: limit,
      ...searchConditions, 
    };
    const response = await axiosCilent.post(`getUserListDb`, requestBody, { timeout: 0 });

    const users = toCamelCase(removeNullFields(response.data.users));
    const userDataList: UserData[] = users.map((user: any) => ({
      ...UserItemMapingFromDb(user),
      salt: null,
      encryptedPasscode: null,
      decryptedPasscode: null,
      password: null,
      passcode: null,
      iv: null,
      possessedPointMap: user.possessedPoints
        ? Object.values(user.possessedPoints).map((p: any) => ({
            id: p.id,
            name: p.name,
            point: p.point ?? 0,
          }))
        : [],
      expirationPointMap: [],
    }));

    return {
      success: true,
      users: userDataList,
      totalCount: response.data.totalCount,
      totalPages: response.data.totalPages,
    };
  } catch (error) {
    return { success: false, error };
  }
};

export const requestGetTargetUser = async (
  tenantId: string,
  userId: string[],
  emptyName: boolean,
  accountSuspensionFlg: boolean | null
): Promise<{
  success: true;
  users: User[];
  totalCount: number;
} | { success: false; error: any }> => {
  try {
    const requestBody = {
      tenantId,
      userId,
      emptyName,
      accountSuspensionFlg 
    };
    const response = await axiosCilent.post(`getTargetUserListDb`, requestBody, { timeout: 0 });

    const users = toCamelCase(removeNullFields(response.data.users));
    const userDataList: User[] = users.map((user: any) => UserItemMapingFromDb(user));

    return {
      success: true,
      users: userDataList,
      totalCount: response.data.totalCount
    };
  } catch (error) {
    return { success: false, error };
  }
};

export const requestBulkUpdateUsers = async (
  tenantId: string, 
  users: UserData[], 
  companyDisplayId: string,
  userMap: Record<string, UserData>
) => {
  try {
    const response = await axiosCilent.post(`bulkUpdateUsers`, {
      tenantId,
      bulkUpdateList: users,
      companyDisplayId,
      userMap
    }, { timeout: 0 });

    console.log("Bulk update response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Bulk update error:", error);

    if (error.response) {
      // サーバーからのレスポンスがある場合
      console.error("Response status:", error.response.status);
      console.error("Response headers:", error.response.headers);
      console.error("Response data:", error.response.data);
    } else if (error.request) {
      // リクエストは送ったが応答がない場合
      console.error("Request was made but no response received:", error.request);
    } else {
      // その他、設定やコード上のエラー
      console.error("Axios config / setup error:", error.message);
    }

    return { success: false, error };
  }
};

export const updatepointAssignmentAuthorityData = async (
  tenantId: string, 
  users: User[], 
  companyDisplayId: string,
  userMap: Record<string, UserData>
) => {
  try {
    const response = await axiosCilent.post(`bulkUpdatePointAssignmentAuthority`, {
      tenantId,
      bulkUpdateList: users,
      companyDisplayId,
      userMap
    }, { timeout: 0 });

    console.log("Bulk update response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Bulk update error:", error);

    if (error.response) {
      // サーバーからのレスポンスがある場合
      console.error("Response status:", error.response.status);
      console.error("Response headers:", error.response.headers);
      console.error("Response data:", error.response.data);
    } else if (error.request) {
      // リクエストは送ったが応答がない場合
      console.error("Request was made but no response received:", error.request);
    } else {
      // その他、設定やコード上のエラー
      console.error("Axios config / setup error:", error.message);
    }

    return { success: false, error };
  }
};